

/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;




//////////////////
// WEBPACK FOOTER
// ../node_modules/get-proto/Reflect.getPrototypeOf.js
// module id = ../node_modules/get-proto/Reflect.getPrototypeOf.js
// module chunks = 0